import React from 'react';
import styled from 'styled-components';
import { HorizontalGroup, Text, Input, Tooltip } from '@libs/uikit/Components';
import { DottedBorder } from './DottedBorder';
import { ActionButton } from './ActionButton';

const AdableInput = styled.div`
    position: relative;
`;

export const ListItem = ({ urls, i, item: { url }, update }) => {
    const { isPortrait, hasError } = urls[i];
    const handleInputChange = ({ target: { value: url } }) => {
        urls[i] = { url, isPortrait, hasError: !url.startsWith('https://') };
        update([...urls]);
    };
    const setCheckboxState = () => {
        urls[i] = { url, isPortrait: !isPortrait, hasError: false };
        update([...urls]);
    };

    const add = () => {
        if (urls.length < 5) {
            update([...urls, { url: '', isPortrait: false, hasError: false }]);
        }
    };

    const remove = () => {
        if (urls.length > 1) {
            update(urls.filter((_, idx) => i !== idx));
        }
    };

    return (
        <HorizontalGroup>
            <DottedBorder>
                <span></span>
            </DottedBorder>
            <AdableInput>
                <Input
                    name="input"
                    placeholder="VAST/VPAID URL"
                    value={url}
                    onChange={handleInputChange}
                    error={hasError}
                />
                {hasError && <Tooltip error text={'In this field should be https url'} />}
                <ActionButton plus onClick={add} />
                <ActionButton minus onClick={remove} />
            </AdableInput>
            <input type="checkbox" checked={isPortrait} onChange={setCheckboxState} />
            <Text onClick={setCheckboxState} caption="true" inline="true" noMargin="true">
                Portrait
            </Text>
        </HorizontalGroup>
    );
};
